// Monte Carlo utilities extracted and adapted from ClarityFi-Monte-Carlo.html

export function boxMullerNormal(mean = 0, sd = 1) {
  let u = 0, v = 0;
  while (u === 0) u = Math.random();
  while (v === 0) v = Math.random();
  return mean + sd * Math.sqrt(-2 * Math.log(u)) * Math.cos(2 * Math.PI * v);
}

export function percentile(arr, p) {
  if (!arr?.length) return 0;
  const sorted = [...arr].sort((a, b) => a - b);
  const idx = (sorted.length - 1) * p;
  const lo = Math.floor(idx);
  const hi = Math.ceil(idx);
  return sorted[lo] + (sorted[hi] - sorted[lo]) * (idx - lo);
}

export function histogram(values, bins = 10) {
  if (!values?.length) return { edges: [], counts: [] };
  const min = Math.min(...values);
  const max = Math.max(...values);
  const step = (max - min) / Math.max(1, bins);
  const edges = Array.from({ length: bins + 1 }, (_, i) => min + i * step);
  const counts = Array(bins).fill(0);
  values.forEach(v => {
    let b = step > 0 ? Math.floor((v - min) / step) : 0;
    if (b >= bins) b = bins - 1;
    if (b < 0) b = 0;
    counts[b]++;
  });
  return { edges, counts };
}

export function runMonteCarlo({ startCorpus, income, expense, meanReturn, sdReturn, meanInflation, sdInflation, years, runs }) {
  const allRuns = [];
  for (let r = 0; r < runs; r++) {
    let corpus = startCorpus;
    const path = [];
    for (let y = 0; y < years; y++) {
      const ret = boxMullerNormal(meanReturn, sdReturn);
      const inf = boxMullerNormal(meanInflation, sdInflation);
      corpus = Math.max(0, corpus * (1 + ret - inf) + (income - expense));
      path.push(corpus);
    }
    allRuns.push(path);
  }
  return allRuns;
}

export function summarize(allRuns, targetCorpus) {
  const years = allRuns[0]?.length || 0;
  const finals = allRuns.map(r => r[years - 1]);
  const avg = Array.from({ length: years }, (_, i) =>
    allRuns.reduce((s, r) => s + (r[i] || 0), 0) / Math.max(1, allRuns.length)
  );
  const success = finals.filter(v => v > targetCorpus).length / Math.max(1, allRuns.length);
  return {
    p5: percentile(finals, 0.05),
    p50: percentile(finals, 0.5),
    p95: percentile(finals, 0.95),
    success,
    avg,
    hist: histogram(finals, 12)
  };
}


